import logInApi from '@/api/post/login';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import { Heading1Text } from '@/utils/global-fonts';
import { useMutation } from '@/hooks/use-api';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import verifyApi from '@/api/get/verify-token';
import LoginForm from './login-form';

/**
 * Login page
 * @returns {JSX.Element}
 */
const Login = () => {
  const navigate = useNavigate();
  const [loginUser, { loading: loginLoading }] = useMutation(logInApi);

  // Here we need to verify if the user are logged in or not
  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      verifyApi().then((data) => {
        if (data.success) {
          if (data.userType === 'user') {
            navigate('/app/dashboard');
          } else {
            navigate('/shop/sales-flow');
          }
        }
      });
    }
  });
  return (
    <PageWrapper>
      <Heading1Text>Please Login</Heading1Text>
      <FormWrapper
        defaultValues={{
          email: '',
          password: '',
        }}
        onEnterKeyPress
        onSubmit={(form) => {
          loginUser({
            email: form.email,
            password: form.password,
            keepMeSignedIn: form.keepMeSignedIn,
          }).then(({ data }) => {
            navigate('/verify', { state: data });
          });
        }}
      >
        <LoginForm loading={loginLoading} />
      </FormWrapper>
    </PageWrapper>
  );
};

export default Login;
